import { useMemo } from 'react';
import { useEnvironment } from '@atlassian/jira-tenant-context-controller/src/components/environment/index.tsx';
import { FIGMA_APP_ID, FIGMA_APP_ID_STG } from './constants.tsx';

export const useFigmaProviderId = () => {
	const environment = useEnvironment();

	return useMemo(() => (environment === 'prod' ? FIGMA_APP_ID : FIGMA_APP_ID_STG), [environment]);
};
